/**
 * @generated SignedSource<<00415f3826047b6a721b9e8f5378c8f2>>
 * @relayHash fc3ebf4d2198d603c6f852b3d2c3397c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e06561cdaf6ddbaf6ad69f9392becf2232d6b8ca4f30078f9cc0686b8a0b203d

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceAnalyticsAccountType = "AGENT" | "USER" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type usePageViewsAnalyticsViewersQuery$variables = {
  contentId: string;
  engageTimeThreshold?: number | null;
  isAgentPrivacyMaskingEnabled?: boolean | null;
  isPrivacyModeEnabled?: boolean | null;
  limit?: number | null;
};
export type usePageViewsAnalyticsViewersQuery$data = {
  readonly singleContent: {
    readonly contentAnalyticsViewsByUser: {
      readonly pageViews: ReadonlyArray<{
        readonly accountType: ConfluenceAnalyticsAccountType | null;
        readonly agentType: string | null;
        readonly confluenceUser: {
          readonly permissionType: SitePermissionType | null;
        } | null;
        readonly isEngaged: boolean | null;
        readonly isPrivate?: boolean | null;
        readonly lastVersionViewedNumber: number | null;
        readonly lastVersionViewedUrl: string | null;
        readonly lastViewedAt: string;
        readonly relatedUser: {
          readonly displayName: string | null;
          readonly id: string | null;
          readonly photos: ReadonlyArray<{
            readonly isPrimary: boolean | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly relatedUserAccountId: string | null;
        readonly userId?: string;
        readonly userProfile: {
          readonly displayName: string | null;
          readonly id: string | null;
          readonly isActive: boolean | null;
          readonly photos: ReadonlyArray<{
            readonly isPrimary: boolean | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly views: number;
      }>;
    } | null;
    readonly id: string | null;
    readonly subType: string | null;
    readonly version: {
      readonly number: number | null;
    } | null;
  } | null;
};
export type usePageViewsAnalyticsViewersQuery = {
  response: usePageViewsAnalyticsViewersQuery$data;
  variables: usePageViewsAnalyticsViewersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "engageTimeThreshold"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isAgentPrivacyMaskingEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPrivacyModeEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "subType"
},
v8 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "number"
    }
  ]
},
v9 = [
  {
    "kind": "Variable",
    "name": "engageTimeThreshold",
    "variableName": "engageTimeThreshold"
  },
  {
    "kind": "Variable",
    "name": "isPrivacyModeEnabled",
    "variableName": "isPrivacyModeEnabled"
  },
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v11 = {
  "concreteType": "AtlassianUserPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "value"
    },
    {
      "kind": "ScalarField",
      "name": "isPrimary"
    }
  ]
},
v12 = {
  "concreteType": "ContentAnalyticsPageViewInfo",
  "kind": "LinkedField",
  "name": "pageViews",
  "plural": true,
  "selections": [
    {
      "condition": "isAgentPrivacyMaskingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "userId"
        },
        {
          "kind": "ScalarField",
          "name": "isPrivate"
        }
      ]
    },
    {
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "userProfile",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isActive"
        }
      ]
    },
    {
      "concreteType": "ConfluenceUser",
      "kind": "LinkedField",
      "name": "confluenceUser",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "permissionType"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "accountType"
    },
    {
      "kind": "ScalarField",
      "name": "agentType"
    },
    {
      "kind": "ScalarField",
      "name": "relatedUserAccountId"
    },
    {
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "relatedUser",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "views"
    },
    {
      "kind": "ScalarField",
      "name": "lastViewedAt"
    },
    {
      "kind": "ScalarField",
      "name": "lastVersionViewedNumber"
    },
    {
      "kind": "ScalarField",
      "name": "lastVersionViewedUrl"
    },
    {
      "kind": "ScalarField",
      "name": "isEngaged"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "usePageViewsAnalyticsViewersQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "args": (v9/*: any*/),
            "concreteType": "ContentAnalyticsViewsByUser",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewsByUser",
            "plural": false,
            "selections": [
              (v12/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "usePageViewsAnalyticsViewersQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "args": (v9/*: any*/),
            "concreteType": "ContentAnalyticsViewsByUser",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewsByUser",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "fc3ebf4d2198d603c6f852b3d2c3397c",
    "id": "e06561cdaf6ddbaf6ad69f9392becf2232d6b8ca4f30078f9cc0686b8a0b203d",
    "metadata": {},
    "name": "usePageViewsAnalyticsViewersQuery",
    "operationKind": "query",
    "text": "query usePageViewsAnalyticsViewersQuery($contentId:ID!,$limit:Int,$engageTimeThreshold:Int,$isPrivacyModeEnabled:Boolean,$isAgentPrivacyMaskingEnabled:Boolean=false){singleContent(id:$contentId){id,subType,version{number},contentAnalyticsViewsByUser(limit:$limit,engageTimeThreshold:$engageTimeThreshold,isPrivacyModeEnabled:$isPrivacyModeEnabled){pageViews{userId@include(if:$isAgentPrivacyMaskingEnabled)\n        isPrivate@include(if:$isAgentPrivacyMaskingEnabled),userProfile{id,displayName,photos{value,isPrimary},isActive},confluenceUser{permissionType},accountType,agentType,relatedUserAccountId,relatedUser{id,displayName,photos{value,isPrimary}},views,lastViewedAt,lastVersionViewedNumber,lastVersionViewedUrl,isEngaged},id}}}"
  }
};
})();

(node as any).hash = "f5ec5edd7007acfe540bf601a5d56d72";

export default node;
